/**
 * @module Track
 */
import {getField, updateField} from 'vuex-map-fields';
import {mixin} from "../../helpers/helper";

export default {
    mixins: [mixin],
    namespaced: true,
    state: {
        path: '',
        bread_active: {
            'label': 'Le novità su Real Estate Pro'
        },
        bread_list: [],
        versionData: [],
        votesListData: [],
        idToVote: 0,
        voteResult: true,
        singleProposal: '',

    },
    getters: {
        getField
    },
    mutations: {
        updateField,

        setData: function (state, data) {
            eval("state." + data.name + " = data.data;");
        }
    },
    actions: {

        create: function (state, component) {
            axios.post('/api/v1/track/create', {
                path: window.location.pathname,
                search: window.location.search,
                component: component
            });
        },

        versionList: function (state) {
            axios.get('/api/v1/version/')
                .then(response => {
                    state.commit('setData', {data: response.data.versionData, name: 'versionData'});
                })
        },

        votesList: function (state) {
            axios.get('/api/v1/votes')
                .then(response => {
                    state.commit('setData', {data: response.data, name: 'votesListData'})
                })
        },

        sendVote: function (state) {
            axios.post('/api/v1/votes/create', {
                id: state.state.idToVote,
            })
                .then(response => {
                    state.commit('setData', {data: response.data, name: 'voteResult'});
                    state.commit('setData', {data: 0, name: 'idToVote'});
                    state.dispatch('votesList');
                })

        },

        sendSingleProposal: function(state)
        {
            axios.post('/api/v1/votes/singleProposal/create', {
                singleProposal: state.state.singleProposal
            })
                .then(response =>{

                })
        }

    }
}